module.exports = __webpack_public_path__ + "static/img/pic10.6d38f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic10.png
// module id = a9qs
// module chunks = 0